import { Wrapper } from '@american-autonomy/ag-ui';

import EntitySelectPillButton from 'components/EntitySelectPillButton';
import WithField from 'components/WithField';
import CalibrationKindSelectPanelField from 'components/fields/CalibrationKindSelectPanelField';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FieldValues, Props } from './types';

import styles from './styles.module.scss';

const SelectCalibrationKindField = <T extends FieldValues>(props: Props<T>) => {
    const {
        className = '',
        control,
        isOpen,
        isPlain,
        isRequired,
        label,
        name,
        onPanelClose,
        onPanelOpen,
        placeholder,
        ref,
        testId = TEST_ID
    } = props;

    const { CALIBRATION_TYPE } = useTranslation();

    const { containerRef, handleClose, handleToggle, isPanelOpen, onChange, value } = useData<T>({
        control,
        isOpen,
        isRequired,
        name,
        onPanelClose,
        onPanelOpen,
        ref
    });

    const fieldLabel = label ?? CALIBRATION_TYPE;

    return (
        <Wrapper className={`${styles.wrapper} ${className}`} ref={containerRef} testId={testId}>
            <WithField isPlain={isPlain} isRequired={isRequired} label={fieldLabel}>
                <EntitySelectPillButton
                    className={styles.pillButton}
                    hasValue={!!value}
                    onClick={handleToggle}
                    onRemove={() => onChange(null)}
                    text={value?.label ?? placeholder ?? CALIBRATION_TYPE}
                />
            </WithField>

            {isPanelOpen && (
                <CalibrationKindSelectPanelField
                    onChange={onChange}
                    onClose={handleClose}
                    value={value}
                />
            )}
        </Wrapper>
    );
};

export default SelectCalibrationKindField;
